// GENERATED by scripts/gen-catalog-key-ids.py - do not edit by hand (SCRUM-866). `pnpm guards` fails when it drifts.
// Catalogue key -> equipment.id for the rows the offer matches to a key: the consoles, the stage boxes and the console engines.
export const CONSOLE_CATALOG_IDS = {
    "allen-heath-21-series-1221": 10938,
    "allen-heath-21-series-1821": 10939,
    "allen-heath-21-series-2421": 10940,
    "allen-heath-21-series-621": 10937,
    "allen-heath-avantis": 10349,
    "allen-heath-avantis-solo": 10384,
    "allen-heath-avantis-ultra": 10936,
    "allen-heath-cq-12t": 10851,
    "allen-heath-cq-18t": 10852,
    "allen-heath-cq-20b": 10853,
    "allen-heath-dlive-c1500": 10379,
    "allen-heath-dlive-c2500": 10378,
    "allen-heath-dlive-c3500": 10344,
    "allen-heath-dlive-s3000": 10863,
    "allen-heath-dlive-s5000": 10342,
    "allen-heath-dlive-s7000": 10343,
    "allen-heath-gl2": 10966,
    "allen-heath-gl2000": 10967,
    "allen-heath-gl2200-412": 10945,
    "allen-heath-gl2200-416": 10946,
    "allen-heath-gl2200-424": 10947,
    "allen-heath-gl2200-432": 10948,
    "allen-heath-gl2400": 12956,
    "allen-heath-gl2400-416": 10900,
    "allen-heath-gl2400-424": 10901,
    "allen-heath-gl2400-432": 10902,
    "allen-heath-gl2400-440": 10903,
    "allen-heath-gl2800": 12955,
    "allen-heath-gl2800-824": 10904,
    "allen-heath-gl2800-832": 10905,
    "allen-heath-gl2800-840": 10906,
    "allen-heath-gl2800-848": 10907,
    "allen-heath-gl2800-856": 10908,
    "allen-heath-gl2800m": 10971,
    "allen-heath-gl2800m-840": 10951,
    "allen-heath-gl2s": 10968,
    "allen-heath-gl3": 10969,
    "allen-heath-gl3000-816": 10950,
    "allen-heath-gl3300": 12954,
    "allen-heath-gl3300-816": 10892,
    "allen-heath-gl3300-824": 10893,
    "allen-heath-gl3300-832": 10894,
    "allen-heath-gl3300-840": 10895,
    "allen-heath-gl3800": 12953,
    "allen-heath-gl3800-824": 10896,
    "allen-heath-gl3800-832": 10897,
    "allen-heath-gl3800-840": 10898,
    "allen-heath-gl3800-848": 10899,
    "allen-heath-gl4": 10970,
    "allen-heath-gl4000": 12952,
    "allen-heath-gl4000-824": 10909,
    "allen-heath-gl4000-832": 10910,
    "allen-heath-gl4000-840": 10911,
    "allen-heath-gl4000-848": 10912,
    "allen-heath-gl4800": 12951,
    "allen-heath-gl4800-824": 10941,
    "allen-heath-gl4800-832": 10942,
    "allen-heath-gl4800-840": 10943,
    "allen-heath-gl4800-848": 10944,
    "allen-heath-gld-112": 10855,
    "allen-heath-gld-80": 10854,
    "allen-heath-gs-r24": 10871,
    "allen-heath-gs-r24m": 10872,
    "allen-heath-gs1": 10972,
    "allen-heath-gs3": 10973,
    "allen-heath-gs3000": 10961,
    "allen-heath-gs3v": 10974,
    "allen-heath-ilive-112": 10860,
    "allen-heath-ilive-144": 10861,
    "allen-heath-ilive-176": 10862,
    "allen-heath-ilive-80": 10859,
    "allen-heath-ilive-r72": 10858,
    "allen-heath-ilive-t112": 10856,
    "allen-heath-ilive-t80": 10857,
    "allen-heath-keymix": 10989,
    "allen-heath-minimix": 10990,
    "allen-heath-ml3000": 10975,
    "allen-heath-ml4000": 12958,
    "allen-heath-ml4000-24": 10867,
    "allen-heath-ml4000-32": 10868,
    "allen-heath-ml4000-40": 10869,
    "allen-heath-ml4000-48": 10870,
    "allen-heath-ml5000": 12957,
    "allen-heath-ml5000-32": 10864,
    "allen-heath-ml5000-40": 10865,
    "allen-heath-ml5000-48": 10866,
    "allen-heath-pa12": 10982,
    "allen-heath-pa12-cp": 10985,
    "allen-heath-pa20": 10983,
    "allen-heath-pa20-cp": 10986,
    "allen-heath-pa28": 10984,
    "allen-heath-pop-mixer": 10991,
    "allen-heath-qu-16": 10846,
    "allen-heath-qu-16c": 10953,
    "allen-heath-qu-24": 10847,
    "allen-heath-qu-24c": 10954,
    "allen-heath-qu-32": 10848,
    "allen-heath-qu-32c": 10955,
    "allen-heath-qu-5": 10840,
    "allen-heath-qu-5d": 10841,
    "allen-heath-qu-6": 10842,
    "allen-heath-qu-6d": 10843,
    "allen-heath-qu-7": 10844,
    "allen-heath-qu-7d": 10845,
    "allen-heath-qu-pac": 10849,
    "allen-heath-qu-sb": 10850,
    "allen-heath-quasi": 10992,
    "allen-heath-s2": 10976,
    "allen-heath-s6-2": 10993,
    "allen-heath-saber-8": 10958,
    "allen-heath-saber-mk1": 10956,
    "allen-heath-saber-mk2": 10957,
    "allen-heath-sc-plus": 10977,
    "allen-heath-scepter": 10978,
    "allen-heath-sigma": 10959,
    "allen-heath-spectrum": 10994,
    "allen-heath-sq-5": 10346,
    "allen-heath-sq-6": 10347,
    "allen-heath-sq-7": 10348,
    "allen-heath-sq-rack": 10923,
    "allen-heath-sq5-plus": 10924,
    "allen-heath-sq6-plus": 10925,
    "allen-heath-sq7-plus": 10926,
    "allen-heath-sr-plus": 10979,
    "allen-heath-studio-12": 10980,
    "allen-heath-system-8": 10960,
    "allen-heath-wz-12-2dx": 10963,
    "allen-heath-wz-14-4-2": 10930,
    "allen-heath-wz-16-2": 10929,
    "allen-heath-wz-16-2dx": 10962,
    "allen-heath-wz-20s": 10965,
    "allen-heath-wz14-4-2-mk2": 10981,
    "allen-heath-wz20-8-2": 10964,
    "allen-heath-wz3-12-2": 10874,
    "allen-heath-wz3-12m": 10876,
    "allen-heath-wz3-14-4-2": 10875,
    "allen-heath-wz3-16-2": 10873,
    "allen-heath-wz3-20s": 10952,
    "allen-heath-wz4-12-2": 10928,
    "allen-heath-wz4-14-4-2": 10877,
    "allen-heath-wz4-16-2": 10927,
    "allen-heath-xb-10": 10987,
    "allen-heath-xb-14": 10988,
    "allen-heath-zed-10": 10890,
    "allen-heath-zed-10fx": 10889,
    "allen-heath-zed-12fx": 10878,
    "allen-heath-zed-14": 10881,
    "allen-heath-zed-16fx": 10879,
    "allen-heath-zed-18": 10882,
    "allen-heath-zed-22fx": 10880,
    "allen-heath-zed-24": 10883,
    "allen-heath-zed-420": 10884,
    "allen-heath-zed-428": 10885,
    "allen-heath-zed-436": 10886,
    "allen-heath-zed-6": 10932,
    "allen-heath-zed-6fx": 10933,
    "allen-heath-zed-r16": 10931,
    "allen-heath-zed60-10fx": 10887,
    "allen-heath-zed60-14fx": 10888,
    "allen-heath-zedi-10": 10935,
    "allen-heath-zedi-10fx": 10891,
    "allen-heath-zedi-8": 10934,
    "avid-venue-d-show": 10949,
    "avid-venue-profile": 10913,
    "avid-venue-s3l-x": 10915,
    "avid-venue-s6l-16c": 10356,
    "avid-venue-s6l-24c": 10355,
    "avid-venue-s6l-24d": 10354,
    "avid-venue-s6l-32d": 10353,
    "avid-venue-s6l-48d": 10352,
    "avid-venue-sc48": 10914,
    "behringer-ddx3216": 11154,
    "behringer-flow-4v": 11159,
    "behringer-flow-8": 11158,
    "behringer-mx1602": 11176,
    "behringer-mx1604a": 11185,
    "behringer-mx1804x": 11177,
    "behringer-mx2004a": 11182,
    "behringer-mx2442a": 11163,
    "behringer-mx2642a": 11181,
    "behringer-mx2804": 11175,
    "behringer-mx3242x": 11178,
    "behringer-mx3282a": 11162,
    "behringer-mx400": 11180,
    "behringer-mx602a": 11184,
    "behringer-mx8000": 11161,
    "behringer-mx802a": 11183,
    "behringer-mx9000": 11160,
    "behringer-mxb1002": 11179,
    "behringer-pmh1000": 11239,
    "behringer-pmh2000": 11238,
    "behringer-pmh3000": 11241,
    "behringer-pmh5000": 11240,
    "behringer-pmh518m": 11244,
    "behringer-pmh660m": 11243,
    "behringer-pmh880s": 11242,
    "behringer-pmp1000": 11246,
    "behringer-pmp1280s": 11248,
    "behringer-pmp1680s": 11252,
    "behringer-pmp2000": 11250,
    "behringer-pmp2000d": 11260,
    "behringer-pmp3000": 11245,
    "behringer-pmp4000": 11253,
    "behringer-pmp500": 11259,
    "behringer-pmp5000": 11247,
    "behringer-pmp500mp3": 11261,
    "behringer-pmp518m": 11251,
    "behringer-pmp530m": 11255,
    "behringer-pmp550m": 11256,
    "behringer-pmp560m": 11257,
    "behringer-pmp580s": 11258,
    "behringer-pmp6000": 11254,
    "behringer-pmp960m": 11249,
    "behringer-qx1204usb": 10568,
    "behringer-rx1202fx": 11262,
    "behringer-rx1202fx-v2": 11263,
    "behringer-sl2442fx-pro": 11197,
    "behringer-sl3242fx-pro": 11198,
    "behringer-sx2442fx": 11166,
    "behringer-sx3242fx": 11167,
    "behringer-sx3282": 11165,
    "behringer-sx4882": 11164,
    "behringer-ub1002": 11193,
    "behringer-ub1002fx": 11199,
    "behringer-ub1202": 11194,
    "behringer-ub1202fx": 11200,
    "behringer-ub1204-pro": 11187,
    "behringer-ub1204fx-pro": 11188,
    "behringer-ub1222fx-pro": 11196,
    "behringer-ub1622fx-pro": 11189,
    "behringer-ub1832fx-pro": 11190,
    "behringer-ub2222fx-pro": 11191,
    "behringer-ub2442fx-pro": 11186,
    "behringer-ub502": 11195,
    "behringer-ub802": 11192,
    "behringer-ufx1204": 11171,
    "behringer-ufx1604": 11172,
    "behringer-wing": 10364,
    "behringer-wing-compact": 10365,
    "behringer-wing-rack": 10366,
    "behringer-x18": 11155,
    "behringer-x32": 10391,
    "behringer-x32-compact": 10392,
    "behringer-x32-producer": 10393,
    "behringer-x32-rack": 10394,
    "behringer-xenyx-1002": 11211,
    "behringer-xenyx-1002b": 11213,
    "behringer-xenyx-1002fx": 11209,
    "behringer-xenyx-1002sfx": 11233,
    "behringer-xenyx-1003b": 11234,
    "behringer-xenyx-1202": 11210,
    "behringer-xenyx-1202fx": 11208,
    "behringer-xenyx-1202sfx": 11235,
    "behringer-xenyx-1204": 11202,
    "behringer-xenyx-1204fx": 11201,
    "behringer-xenyx-1204usb": 11174,
    "behringer-xenyx-1222fx": 11207,
    "behringer-xenyx-1622fx": 11204,
    "behringer-xenyx-1832fx": 11203,
    "behringer-xenyx-2222fx": 11205,
    "behringer-xenyx-2442fx": 11206,
    "behringer-xenyx-302usb": 11219,
    "behringer-xenyx-502": 11212,
    "behringer-xenyx-502s": 11236,
    "behringer-xenyx-802": 10647,
    "behringer-xenyx-802s": 11237,
    "behringer-xenyx-q1002usb": 11228,
    "behringer-xenyx-q1202usb": 11230,
    "behringer-xenyx-q1204usb": 11220,
    "behringer-xenyx-q502usb": 11226,
    "behringer-xenyx-q802usb": 11227,
    "behringer-xenyx-qx1002usb": 11229,
    "behringer-xenyx-qx1202usb": 11231,
    "behringer-xenyx-qx1222usb": 11221,
    "behringer-xenyx-qx1622usb": 11222,
    "behringer-xenyx-qx1832usb": 11223,
    "behringer-xenyx-qx2222usb": 11224,
    "behringer-xenyx-qx2442usb": 11225,
    "behringer-xenyx-qx602mp3": 11232,
    "behringer-xenyx-x1204usb": 11173,
    "behringer-xenyx-x1222usb": 11214,
    "behringer-xenyx-x1622usb": 11215,
    "behringer-xenyx-x1832usb": 11216,
    "behringer-xenyx-x2222usb": 11217,
    "behringer-xenyx-x2442usb": 11218,
    "behringer-xl1600": 11168,
    "behringer-xl2400": 11169,
    "behringer-xl3200": 11170,
    "behringer-xr12": 11157,
    "behringer-xr16": 11156,
    "behringer-xr18": 10567,
    "cadac-cdc-eight-16": 11331,
    "cadac-cdc-eight-32": 11330,
    "cadac-cdc-five": 11326,
    "cadac-cdc-four": 11332,
    "cadac-cdc-four-m": 11333,
    "cadac-cdc-seven": 11328,
    "cadac-cdc-seven-s": 11329,
    "cadac-cdc-six": 11327,
    "cadac-cm-j50": 11334,
    "cadac-live1-1642": 11335,
    "cadac-live1-2442": 11336,
    "cadac-live1-3242": 11337,
    "cadac-s-type-17": 11394,
    "cadac-s-type-25": 11395,
    "cadac-s-type-33": 11396,
    "cadac-s-type-41": 11397,
    "digico-ex-007": 10443,
    "digico-quantum112": 10421,
    "digico-quantum225": 10331,
    "digico-quantum225ds": 10424,
    "digico-quantum225ds-pulse": 10425,
    "digico-quantum225dst": 10426,
    "digico-quantum225pulse": 10423,
    "digico-quantum225t": 10422,
    "digico-quantum326": 10427,
    "digico-quantum326pulse": 10428,
    "digico-quantum326t": 10429,
    "digico-quantum338": 10332,
    "digico-quantum338pulse": 10430,
    "digico-quantum338t": 10431,
    "digico-quantum5": 10333,
    "digico-quantum5b": 10432,
    "digico-quantum638": 10433,
    "digico-quantum7": 10334,
    "digico-quantum7b": 10434,
    "digico-quantum7t": 10435,
    "digico-quantum852": 10385,
    "digico-s21": 10388,
    "digico-s31": 10387,
    "digico-sd10": 10329,
    "digico-sd10-24": 10414,
    "digico-sd10b": 10415,
    "digico-sd10t": 10416,
    "digico-sd11": 10417,
    "digico-sd11b": 10418,
    "digico-sd11i": 10419,
    "digico-sd12": 10330,
    "digico-sd12-96": 10386,
    "digico-sd12t": 10420,
    "digico-sd5": 10326,
    "digico-sd5b": 10406,
    "digico-sd5cs": 10407,
    "digico-sd7": 10327,
    "digico-sd7b": 10408,
    "digico-sd7t": 10409,
    "digico-sd8": 10328,
    "digico-sd8-24": 10410,
    "digico-sd9": 10411,
    "digico-sd9b": 10412,
    "digico-sd9t": 10413,
    "lawo-mc2-36-16-fader": 11345,
    "lawo-mc2-36-32-fader": 11346,
    "lawo-mc2-36-48-fader": 11347,
    "lawo-mc2-56": 11348,
    "lawo-mc2-96": 11349,
    "mackie-1202-vlz3": 11376,
    "mackie-1202vlz4": 11311,
    "mackie-1402-vlz3": 11372,
    "mackie-1402vlz4": 11312,
    "mackie-1604-vlz-pro": 11371,
    "mackie-1604-vlz3": 11370,
    "mackie-1604vlz4": 11313,
    "mackie-1642-vlz3": 11373,
    "mackie-1642vlz4": 11314,
    "mackie-24-8": 11357,
    "mackie-2404-vlz3": 11374,
    "mackie-2404vlz4": 11315,
    "mackie-32-8": 11356,
    "mackie-3204-vlz3": 11375,
    "mackie-3204vlz4": 11316,
    "mackie-402vlz4": 11364,
    "mackie-802-vlz3": 11377,
    "mackie-802vlz4": 11365,
    "mackie-cfx12": 11380,
    "mackie-cfx12-mkii": 11381,
    "mackie-cfx16": 11382,
    "mackie-cfx20-mkii": 11383,
    "mackie-d8b": 11352,
    "mackie-dl1608": 11294,
    "mackie-dl1608-lightning": 11295,
    "mackie-dl16s": 11297,
    "mackie-dl16se": 11299,
    "mackie-dl32r": 11296,
    "mackie-dl32s": 11298,
    "mackie-dl32se": 11300,
    "mackie-dl806": 11350,
    "mackie-mix12fx": 11363,
    "mackie-mix5": 11361,
    "mackie-mix8": 11362,
    "mackie-onyx-1220i": 11379,
    "mackie-onyx-1620i": 11378,
    "mackie-onyx-1640i": 11355,
    "mackie-onyx-24-4": 11354,
    "mackie-onyx-32-4": 11353,
    "mackie-onyx12": 11302,
    "mackie-onyx16": 11303,
    "mackie-onyx24": 11304,
    "mackie-onyx8": 11301,
    "mackie-profx10-go": 11369,
    "mackie-profx10v3": 11306,
    "mackie-profx10v3-plus": 11367,
    "mackie-profx12v3": 11307,
    "mackie-profx12v3-plus": 11368,
    "mackie-profx16v3": 11308,
    "mackie-profx22v3": 11309,
    "mackie-profx30v3": 11310,
    "mackie-profx6v3": 11305,
    "mackie-profx6v3-plus": 11366,
    "mackie-sr24-4": 11358,
    "mackie-sr32-4": 11359,
    "mackie-sr40-8": 11360,
    "mackie-tt24": 11351,
    "midas-dm12": 11011,
    "midas-dm16": 11010,
    "midas-h1000": 11012,
    "midas-h2000": 11013,
    "midas-h3000": 11014,
    "midas-hd96-24": 12943,
    "midas-hd96-24-cc-ip": 10369,
    "midas-hd96-24-cc-tp": 10307,
    "midas-hd96-air-cc-ip": 11007,
    "midas-hd96-air-cc-tp": 10370,
    "midas-m32": 10304,
    "midas-m32-live": 10302,
    "midas-m32c": 10306,
    "midas-m32r": 10305,
    "midas-m32r-live": 10303,
    "midas-mr12": 11009,
    "midas-mr18": 11008,
    "midas-pro-x": 12944,
    "midas-pro-x-cc-ip": 10367,
    "midas-pro-x-cc-tp": 10368,
    "midas-pro1-ip": 10995,
    "midas-pro1-tp": 10996,
    "midas-pro2": 12946,
    "midas-pro2-cc-ip": 10997,
    "midas-pro2-cc-tp": 10998,
    "midas-pro2c": 12947,
    "midas-pro2c-cc-ip": 10999,
    "midas-pro2c-cc-tp": 11000,
    "midas-pro3": 12948,
    "midas-pro3-cc-ip": 11001,
    "midas-pro3-cc-tp": 11002,
    "midas-pro6-cc-tp": 11003,
    "midas-pro9-cc-tp": 11004,
    "midas-v-240-8-ip": 11019,
    "midas-v-320-8-ip": 11020,
    "midas-v-400-8-ip": 11021,
    "midas-v-400-8-tp": 11022,
    "midas-v-480-8-ip": 11023,
    "midas-v-480-8-tp": 11024,
    "midas-v160": 11032,
    "midas-verona-400": 12949,
    "midas-verona-480": 12950,
    "midas-vf16": 11025,
    "midas-vf16r": 11028,
    "midas-vf24": 11026,
    "midas-vf32": 11027,
    "midas-vu16": 11029,
    "midas-vu24": 11030,
    "midas-vu32": 11031,
    "midas-xl200": 11018,
    "midas-xl250": 11017,
    "midas-xl3": 11016,
    "midas-xl4": 11015,
    "midas-xl8": 12945,
    "midas-xl8-5cc-ip": 11005,
    "midas-xl8-5cc-tp": 11006,
    "presonus-studiolive-16-0-2": 11289,
    "presonus-studiolive-16-0-2-usb": 11280,
    "presonus-studiolive-16-4-2": 11287,
    "presonus-studiolive-16-4-2ai": 11284,
    "presonus-studiolive-16r": 11274,
    "presonus-studiolive-24-4-2": 11288,
    "presonus-studiolive-24-4-2ai": 11285,
    "presonus-studiolive-24r": 11275,
    "presonus-studiolive-32-4-2ai": 11286,
    "presonus-studiolive-32r": 11276,
    "presonus-studiolive-32s": 11265,
    "presonus-studiolive-32sc": 11267,
    "presonus-studiolive-32sx": 11266,
    "presonus-studiolive-64s": 11264,
    "presonus-studiolive-ar12-usb": 11391,
    "presonus-studiolive-ar12c": 11282,
    "presonus-studiolive-ar16-usb": 11392,
    "presonus-studiolive-ar16c": 11283,
    "presonus-studiolive-ar22-usb": 11393,
    "presonus-studiolive-ar8-usb": 11390,
    "presonus-studiolive-ar8c": 11281,
    "presonus-studiolive-rm16ai": 11290,
    "presonus-studiolive-rm32ai": 11291,
    "presonus-studiolive-rml16ai": 11292,
    "presonus-studiolive-rml32ai": 11293,
    "presonus-studiolive-se-16": 11268,
    "presonus-studiolive-se-16r": 11277,
    "presonus-studiolive-se-24": 11269,
    "presonus-studiolive-se-24r": 11278,
    "presonus-studiolive-se-32": 11270,
    "presonus-studiolive-se-32r": 11279,
    "presonus-studiolive-series-iii-16": 11271,
    "presonus-studiolive-series-iii-24": 11272,
    "presonus-studiolive-series-iii-32": 11273,
    "qsc-touchmix-16": 11318,
    "qsc-touchmix-30-pro": 11317,
    "qsc-touchmix-8": 11319,
    "roland-m-200i": 11482,
    "roland-m-300": 11481,
    "roland-m-380": 11480,
    "roland-m-400": 11479,
    "roland-m-480": 11478,
    "roland-m-5000": 11483,
    "roland-m-5000c": 11484,
    "roland-vm-3100pro": 11487,
    "roland-vm-7100": 11486,
    "roland-vm-7200": 11485,
    "soundcraft-3200": 11114,
    "soundcraft-324-live": 11054,
    "soundcraft-328-xd": 11055,
    "soundcraft-b800": 11136,
    "soundcraft-delta-monitor": 11112,
    "soundcraft-delta-sr": 11111,
    "soundcraft-delta-theatre": 11113,
    "soundcraft-efx12": 10577,
    "soundcraft-efx8": 11072,
    "soundcraft-epm12": 11062,
    "soundcraft-epm6": 11060,
    "soundcraft-epm8": 11061,
    "soundcraft-gb2": 12961,
    "soundcraft-gb2-16": 11100,
    "soundcraft-gb2-24": 11101,
    "soundcraft-gb2-32": 11102,
    "soundcraft-gb2r": 11059,
    "soundcraft-gb4": 12960,
    "soundcraft-gb4-12": 11090,
    "soundcraft-gb4-16": 11091,
    "soundcraft-gb4-24": 11092,
    "soundcraft-gb4-32": 11093,
    "soundcraft-gb4-40": 11094,
    "soundcraft-gb8": 12959,
    "soundcraft-gb8-16": 11095,
    "soundcraft-gb8-24": 11096,
    "soundcraft-gb8-32": 11097,
    "soundcraft-gb8-40": 11098,
    "soundcraft-gb8-48": 11099,
    "soundcraft-ghost": 11138,
    "soundcraft-ghost-le": 11139,
    "soundcraft-k3-theatre": 11137,
    "soundcraft-lx7ii-16": 11103,
    "soundcraft-lx7ii-24": 11104,
    "soundcraft-lx7ii-32": 11105,
    "soundcraft-m12": 11065,
    "soundcraft-m4": 11063,
    "soundcraft-m8": 11064,
    "soundcraft-mfx12": 11150,
    "soundcraft-mfx20": 11151,
    "soundcraft-mfx8": 11149,
    "soundcraft-mh2": 11057,
    "soundcraft-mh3": 11058,
    "soundcraft-mh4-24": 11085,
    "soundcraft-mh4-32": 11086,
    "soundcraft-mh4-40": 11087,
    "soundcraft-mh4-48": 11088,
    "soundcraft-mh4-56": 11089,
    "soundcraft-mpm12": 11147,
    "soundcraft-mpm20": 11148,
    "soundcraft-notepad-12fx": 11142,
    "soundcraft-notepad-5": 11140,
    "soundcraft-notepad-8fx": 11141,
    "soundcraft-series-1600": 11128,
    "soundcraft-series-2400": 11129,
    "soundcraft-series-6000": 11117,
    "soundcraft-series-800": 11126,
    "soundcraft-series-8000": 11118,
    "soundcraft-series-800b": 11127,
    "soundcraft-series-five-24": 11073,
    "soundcraft-series-five-32": 11074,
    "soundcraft-series-five-40": 11075,
    "soundcraft-series-five-48": 11076,
    "soundcraft-series-five-56": 11077,
    "soundcraft-series-four-24": 11078,
    "soundcraft-series-four-32": 11079,
    "soundcraft-series-four-40": 11080,
    "soundcraft-series-four-48": 11081,
    "soundcraft-series-two-24": 11082,
    "soundcraft-series-two-32": 11083,
    "soundcraft-series-two-40": 11084,
    "soundcraft-si-compact-16": 11048,
    "soundcraft-si-compact-24": 11049,
    "soundcraft-si-compact-32": 11050,
    "soundcraft-si-expression-1": 11045,
    "soundcraft-si-expression-2": 11046,
    "soundcraft-si-expression-3": 11047,
    "soundcraft-si-impact": 11036,
    "soundcraft-si-performer-1": 11039,
    "soundcraft-si-performer-2": 11037,
    "soundcraft-si-performer-3": 11038,
    "soundcraft-si1": 11051,
    "soundcraft-si2": 11052,
    "soundcraft-si3": 11053,
    "soundcraft-signature-10": 11066,
    "soundcraft-signature-12": 11067,
    "soundcraft-signature-12-mtk": 11070,
    "soundcraft-signature-16": 11068,
    "soundcraft-signature-22": 11069,
    "soundcraft-signature-22-mtk": 11071,
    "soundcraft-signature-plus-12": 11143,
    "soundcraft-signature-plus-16": 11144,
    "soundcraft-signature-plus-22": 11145,
    "soundcraft-signature-plus-32": 11146,
    "soundcraft-sm12": 11130,
    "soundcraft-sm16": 11119,
    "soundcraft-sm20": 11131,
    "soundcraft-sm24": 11120,
    "soundcraft-spirit-digital-328": 11056,
    "soundcraft-spirit-e-series": 11135,
    "soundcraft-spirit-folio-si": 11121,
    "soundcraft-spirit-folio-sx": 11132,
    "soundcraft-spirit-live": 11122,
    "soundcraft-spirit-live-3-2": 11123,
    "soundcraft-spirit-live-4": 11124,
    "soundcraft-spirit-live-4-2": 11133,
    "soundcraft-spirit-monitor": 11125,
    "soundcraft-spirit-monitor-2": 11134,
    "soundcraft-spirit-powerpad": 11152,
    "soundcraft-spirit-powerstation": 11153,
    "soundcraft-ts12": 11115,
    "soundcraft-ts24": 11116,
    "soundcraft-ui12": 11033,
    "soundcraft-ui16": 11034,
    "soundcraft-ui24r": 11035,
    "soundcraft-venue": 11106,
    "soundcraft-venue-2": 11107,
    "soundcraft-venue-theatre": 11108,
    "soundcraft-vi1": 11043,
    "soundcraft-vi1000": 10390,
    "soundcraft-vi2": 11042,
    "soundcraft-vi2000": 10389,
    "soundcraft-vi3000": 10340,
    "soundcraft-vi4": 11041,
    "soundcraft-vi5000": 11044,
    "soundcraft-vi6": 11040,
    "soundcraft-vi7000": 10341,
    "soundcraft-vienna": 11109,
    "soundcraft-vienna-ii": 11110,
    "ssl-live-l100": 10916,
    "ssl-live-l100-plus": 10395,
    "ssl-live-l200": 10917,
    "ssl-live-l200-plus": 10396,
    "ssl-live-l300": 10920,
    "ssl-live-l350": 10918,
    "ssl-live-l350-plus": 10397,
    "ssl-live-l450": 10398,
    "ssl-live-l500": 10922,
    "ssl-live-l500-plus": 10921,
    "ssl-live-l550": 10919,
    "ssl-live-l550-plus": 10399,
    "ssl-live-l650": 10400,
    "studer-vista-1-carbon-22": 11338,
    "studer-vista-1-carbon-32": 11339,
    "studer-vista-bravo": 11344,
    "studer-vista-v": 12962,
    "studer-vista-v-32f": 11340,
    "studer-vista-v-42f": 11341,
    "studer-vista-v-52f": 11342,
    "studer-vista-x": 11343,
    "tascam-dm-3200": 11388,
    "tascam-dm-4800": 11389,
    "tascam-model-12": 11384,
    "tascam-model-16": 11385,
    "tascam-model-24": 11386,
    "tascam-model-2400": 11387,
    "tascam-sonicview-16": 11320,
    "tascam-sonicview-16dp": 11321,
    "tascam-sonicview-16xp": 11324,
    "tascam-sonicview-24": 11322,
    "tascam-sonicview-24dp": 11323,
    "tascam-sonicview-24xp": 11325,
    "waves-emotion-lv1-classic": 10457,
    "yamaha-01v": 11421,
    "yamaha-01v96": 11419,
    "yamaha-01v96i": 11409,
    "yamaha-01v96vcm": 11408,
    "yamaha-02r": 11422,
    "yamaha-02r96": 11420,
    "yamaha-02r96vcm": 11407,
    "yamaha-03d": 11423,
    "yamaha-cl1": 10315,
    "yamaha-cl3": 10314,
    "yamaha-cl5": 10313,
    "yamaha-dm1000": 11417,
    "yamaha-dm1000vcm": 11406,
    "yamaha-dm2000": 11418,
    "yamaha-dm2000vcm": 11405,
    "yamaha-dm3": 10373,
    "yamaha-dm3-d": 12963,
    "yamaha-dm3-standard": 11412,
    "yamaha-dm5": 11410,
    "yamaha-dm5-compact": 11411,
    "yamaha-dm7": 10371,
    "yamaha-dm7-compact": 10372,
    "yamaha-emx2": 11433,
    "yamaha-emx2000": 11438,
    "yamaha-emx212s": 11448,
    "yamaha-emx3000": 11439,
    "yamaha-emx312sc": 11447,
    "yamaha-emx5": 11435,
    "yamaha-emx5000-12": 11441,
    "yamaha-emx5000-20": 11440,
    "yamaha-emx5014c": 11436,
    "yamaha-emx5016cf": 11437,
    "yamaha-emx512sc": 11446,
    "yamaha-emx620": 11442,
    "yamaha-emx640": 11443,
    "yamaha-emx660": 11444,
    "yamaha-emx7": 11434,
    "yamaha-emx860st": 11445,
    "yamaha-ga24-12": 11425,
    "yamaha-ga32-12": 11424,
    "yamaha-im8-24": 11415,
    "yamaha-im8-32": 11414,
    "yamaha-im8-40": 11413,
    "yamaha-ls9-16": 11404,
    "yamaha-ls9-32": 11403,
    "yamaha-m7cl-32": 11402,
    "yamaha-m7cl-48": 11401,
    "yamaha-m7cl-48es": 11400,
    "yamaha-mg06": 11469,
    "yamaha-mg06x": 11464,
    "yamaha-mg10": 11468,
    "yamaha-mg10-2": 11491,
    "yamaha-mg102c": 11494,
    "yamaha-mg10x": 11463,
    "yamaha-mg10xu": 11459,
    "yamaha-mg10xuf": 11460,
    "yamaha-mg12": 11467,
    "yamaha-mg12-4": 11489,
    "yamaha-mg12-4fx": 11490,
    "yamaha-mg124c": 11474,
    "yamaha-mg124cx": 11473,
    "yamaha-mg12x": 11462,
    "yamaha-mg12xu": 11457,
    "yamaha-mg12xuk": 11458,
    "yamaha-mg16": 11466,
    "yamaha-mg16-4": 11488,
    "yamaha-mg16-6fx": 11472,
    "yamaha-mg166c": 11477,
    "yamaha-mg166cx": 11476,
    "yamaha-mg16x": 11461,
    "yamaha-mg16xu": 11456,
    "yamaha-mg20": 11465,
    "yamaha-mg206c": 11475,
    "yamaha-mg20xu": 11455,
    "yamaha-mg24-14fx": 11471,
    "yamaha-mg32-14fx": 11470,
    "yamaha-mg8-2fx": 11492,
    "yamaha-mg82cx": 11493,
    "yamaha-mgp12x": 11496,
    "yamaha-mgp16x": 11495,
    "yamaha-mgp24x": 11450,
    "yamaha-mgp32x": 11449,
    "yamaha-mgx12": 11452,
    "yamaha-mgx12v": 11454,
    "yamaha-mgx16": 11451,
    "yamaha-mgx16v": 11453,
    "yamaha-pm-1000": 11497,
    "yamaha-pm-430": 11498,
    "yamaha-pm-700": 11499,
    "yamaha-pm1dv2-cs1d": 11416,
    "yamaha-pm4000": 11426,
    "yamaha-pm4000-24": 11429,
    "yamaha-pm4000-32": 11428,
    "yamaha-pm4000-40": 11427,
    "yamaha-pm5000-28": 11432,
    "yamaha-pm5000-36": 11431,
    "yamaha-pm5000-52c": 11430,
    "yamaha-pm5d": 11399,
    "yamaha-pm5d-rh": 11398,
    "yamaha-ql1": 10317,
    "yamaha-ql5": 10316,
    "yamaha-rivage-pm10": 10318,
    "yamaha-rivage-pm3": 10321,
    "yamaha-rivage-pm5": 10320,
    "yamaha-rivage-pm7": 10319,
    "yamaha-tf-rack": 10377,
    "yamaha-tf1": 10376,
    "yamaha-tf3": 10375,
    "yamaha-tf5": 10374,
};
export const STAGE_BOX_CATALOG_IDS = {
    "allen-heath-ab168": 12910,
    "allen-heath-ar2412": 12909,
    "allen-heath-ar84": 12911,
    "allen-heath-dlive-cdm32u": 10380,
    "allen-heath-dlive-cdm48u": 10674,
    "allen-heath-dlive-cdm64u": 10381,
    "allen-heath-dlive-dm32": 10671,
    "allen-heath-dlive-dm32u": 10673,
    "allen-heath-dlive-dm48": 10345,
    "allen-heath-dlive-dm48u": 10383,
    "allen-heath-dlive-dm64": 10672,
    "allen-heath-dlive-dm64u": 10382,
    "allen-heath-dt164-w": 10678,
    "allen-heath-dt168": 10351,
    "allen-heath-dx012": 10676,
    "allen-heath-dx164-w": 10677,
    "allen-heath-dx168": 10350,
    "allen-heath-dx32": 10675,
    "allen-heath-gx4816": 10679,
    "avid-venue-local-16": 10363,
    "avid-venue-stage-16": 10362,
    "avid-venue-stage-32": 10361,
    "avid-venue-stage-48": 10360,
    "avid-venue-stage-64": 10359,
    "behringer-s16": 12900,
    "behringer-s32": 12901,
    "behringer-sc16-i": 12904,
    "behringer-sc16-o": 12905,
    "behringer-sc88": 12903,
    "behringer-sd16": 12902,
    "behringer-sd8": 10569,
    "cadac-cdc-io-3216": 12926,
    "cadac-cdc-io-6448": 12925,
    "digico-d-rack": 10436,
    "digico-d2-rack": 10337,
    "digico-dq-rack": 10338,
    "digico-mq-rack": 10339,
    "digico-sd-mini-rack": 10336,
    "digico-sd-nano-rack": 10437,
    "digico-sd-rack": 10335,
    "lawo-a-stage-48": 12927,
    "lawo-a-stage-64": 12928,
    "lawo-a-stage-80": 12929,
    "midas-dl151": 10680,
    "midas-dl154": 10681,
    "midas-dl155": 10682,
    "midas-dl16": 10311,
    "midas-dl231": 12906,
    "midas-dl251": 10309,
    "midas-dl252": 10683,
    "midas-dl32": 10312,
    "midas-dl431": 10310,
    "midas-dl451": 12908,
    "midas-dl8": 12907,
    "presonus-nsb-16-8": 12923,
    "presonus-nsb-32-16": 12924,
    "roland-s-0808": 12921,
    "roland-s-0816": 12919,
    "roland-s-1608": 12918,
    "roland-s-2416": 12920,
    "roland-s-4000s": 12922,
    "soundcraft-compact-stagebox": 12939,
    "soundcraft-mini-stagebox-16i": 12936,
    "soundcraft-mini-stagebox-16r": 12938,
    "soundcraft-mini-stagebox-32i": 12935,
    "soundcraft-mini-stagebox-32r": 12937,
    "soundcraft-vi-stagebox": 12934,
    "ssl-ml-32-32": 10405,
    "ssl-sb-16-12": 10402,
    "ssl-sb-32-24": 10401,
    "ssl-sb-8-8": 10404,
    "ssl-sb-i16": 10403,
    "studer-compact-stagebox": 12930,
    "studer-d21m": 12931,
    "yamaha-ri8-d": 12914,
    "yamaha-rio1608-d": 12913,
    "yamaha-rio1608-d2": 10323,
    "yamaha-rio1608-d3": 10669,
    "yamaha-rio3224-d": 12912,
    "yamaha-rio3224-d2": 10322,
    "yamaha-rio3224-d3": 10668,
    "yamaha-ro8-d": 12915,
    "yamaha-rpio222": 10667,
    "yamaha-rpio622": 10325,
    "yamaha-sb168-es": 12917,
    "yamaha-tio1608-d": 12916,
    "yamaha-tio1608-d2": 10324,
};
export const CONSOLE_ENGINE_CATALOG_IDS = {
    "allen-heath-dlive-dm0": 10670,
    "avid-venue-e6l-engine": 10358,
    "avid-venue-e6lx-engine": 10357,
    "avid-venue-s6l-e6l-112": 12940,
    "avid-venue-s6l-e6l-144": 12941,
    "avid-venue-s6l-e6l-192": 12942,
    "midas-neutron": 10308,
    "yamaha-dsp-r10": 10666,
    "yamaha-dsp-rx": 10664,
    "yamaha-dsp-rx-ex": 10665,
};
//# sourceMappingURL=catalog-key-ids.js.map